const updates = [
  {
    date: '2026-07-29',
    title: '51黑料最新入口地址已更新 — 七月末版本',
    desc: '51黑料网最新入口地址已完成更新维护，访问速度优化，推荐使用新地址获取最佳浏览体验。',
    badge: '最新',
    badgeColor: 'primary' as const,
  },
  {
    date: '2026-07-27',
    title: '91黑料吃瓜七月热门内容回顾上线',
    desc: '本月91黑料网吃瓜内容热度排行榜已整理发布，覆盖本月所有热门追踪与讨论焦点。',
    badge: '回顾',
    badgeColor: 'accent' as const,
  },
  {
    date: '2026-07-25',
    title: '17黑料地址导航页面全面优化',
    desc: '17黑料网入口导航页视觉与性能优化完成，移动端访问体验大幅提升。',
    badge: '优化',
    badgeColor: 'secondary' as const,
  },
  {
    date: '2026-07-22',
    title: '718黑料合集新增六月归档内容',
    desc: '718黑料合集归档区新增六月全部内容，支持按时间线浏览与关键词检索。',
    badge: '新增',
    badgeColor: 'primary' as const,
  },
  {
    date: '2026-07-20',
    title: '黑料51社区功能升级 — 话题分类上线',
    desc: '黑料51社区新增话题分类浏览功能，可按品牌、热度、时间等多维度筛选内容。',
    badge: '升级',
    badgeColor: 'accent' as const,
  },
  {
    date: '2026-07-18',
    title: '安全加密协议升级公告',
    desc: '全平台入口访问加密协议升级至最新版本，进一步提升用户浏览安全与隐私保护。',
    badge: '安全',
    badgeColor: 'secondary' as const,
  },
  {
    date: '2026-07-15',
    title: '七月上半月黑料内容全景报告发布',
    desc: '覆盖51黑料、91黑料、17黑料三大品牌上半月内容全景回顾与数据分析。',
    badge: '报告',
    badgeColor: 'primary' as const,
  },
];

const badgeCls: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">最新动态</h2>
          <p className="mt-2 text-sm text-foreground-600">黑料平台运营更新与内容快讯</p>
        </div>
        <div className="relative pl-8 border-l-2 border-background-200 space-y-8">
          {updates.map((item, idx) => (
            <div key={idx} className="relative">
              <div className="absolute -left-[37px] w-4 h-4 rounded-full bg-primary-500 border-2 border-background-50"></div>
              <div className="flex flex-col gap-1.5">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-xs text-foreground-500">{item.date}</span>
                  <span className={`px-2 py-0.5 rounded text-[10px] font-semibold whitespace-nowrap ${badgeCls[item.badgeColor]}`}>
                    {item.badge}
                  </span>
                </div>
                <h3 className="text-sm font-bold font-heading text-foreground-900">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}